document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.form-group .form-input').forEach(function(input) {
    function update() {
      if (input === document.activeElement || input.value) {
        input.closest('.form-group').classList.add('is-active');
      } else {
        input.closest('.form-group').classList.remove('is-active');
      }
    }
    input.addEventListener('focus', update);
    input.addEventListener('blur', update);
    input.addEventListener('input', update);
    update();
  });
});